import React from "react";
import { CHANNELS, CHANNEL_COLOR, CHANNEL_LABEL } from "./networkFmt";

const pill = (active) => `px-3 py-1.5 rounded-full text-xs border transition-colors duration-200 flex items-center gap-1.5 ${
    active ? "bg-white text-black border-white" : "border-white/15 text-white/70 hover:bg-white/5 hover:text-white"}`;

/** All servers · one channel (Dev / Stage / Prod across regions) · one server. */
export default function NetworkPicker({ sel, servers, onChange }) {
    return (
        <div className="flex flex-wrap items-center gap-2" data-testid="network-picker">
            <button data-testid="network-scope-all" className={pill(sel.scope === "all")}
                onClick={() => onChange({ scope: "all", channel: null, server: null })}>All servers</button>
            <span className="w-px h-5 bg-white/10 mx-1" />
            {CHANNELS.map((ch) => (
                <button key={ch} data-testid={`network-channel-${ch}`} className={pill(sel.scope === "channel" && sel.channel === ch)}
                    onClick={() => onChange({ scope: "channel", channel: ch, server: null })}>
                    <span className="w-1.5 h-1.5 rounded-full" style={{ background: CHANNEL_COLOR[ch] }} /> {CHANNEL_LABEL[ch]}
                </button>
            ))}
            <span className="w-px h-5 bg-white/10 mx-1" />
            <select data-testid="network-server-select" aria-label="Pick one server"
                value={sel.scope === "server" ? sel.server || "" : ""}
                onChange={(e) => onChange(e.target.value ? { scope: "server", server: e.target.value, channel: null } : { scope: "all", server: null, channel: null })}
                className={`bg-[#0a0a0a] border rounded-full text-xs px-3 py-1.5 max-w-[18rem] ${sel.scope === "server" ? "border-white text-white" : "border-white/15 text-white/70"}`}>
                <option value="">One server…</option>
                {servers.map((s) => (
                    <option key={s.key} value={s.key}>{`${s.name || s.key} — ${s.label}${s.is_self ? " (this server)" : ""}`}</option>
                ))}
            </select>
        </div>
    );
}
